import React from 'react';
import { rem } from 'polished';
import { Button } from 'oxyrion-ui/lib';
import Img from 'react-image';
import styled from 'styled-components';
import { __ } from '../../../../Utils';
import b2bRoles from '../../../../ContentConfig/b2bRoles';
import { connect, actions } from '../../../../Store';
import BaseMarketingLayout from '../../BaseList';
import IconTd from '../../../../Components/ReusableComponents/IconTd';
import CheckAccess from '../../../../ACL/CheckAccess';
import placeholder from '../avatar-placeholder.png';
import API2 from '../../../../API2';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const UserImage = styled(Img)`
  height: ${rem(16)};
  margin-right: ${rem(4)};
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class Users extends BaseMarketingLayout {
  constructor(props) {
    super(props);
    this.pageSizes = [10, 20, 50];
    this.defaultLimit = 10;
    this.state = {
      ...this.state,
      title: __('Používatelia'),
      notFoundMessage: __(
        'Ľutujeme, vyhľadávaniu nezodpovedajú žiadne výsledky ',
      ),
      isProduct: false,
      sorter: 'name',
      limit: 10,
      defaultFilter: [
        {
          id: 'type',
          values: ['b2b_contacts'],
        },
      ],
    };
  }

  componentDidMount() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
    } = this.loadActualData();

    actions.setActiveMenuItem('91');

    let newCheckedFilter =
      checkedFilter && checkedFilter !== 'undefined'
        ? JSON.parse(checkedFilter)
        : [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: [...newCheckedFilter],
      },
      async () => {
        await this.fetchFilter(false);
        this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText, sorter } = this.state;

    try {
      const params = parameters;

      if (checkedFilter) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (!checkedFilter.find(c => c.id === 'type')) {
        checkedFilter.concat(this.state.defaultFilter);
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      params.sorter = sorter;

      const newData = await API2.getB2BUsersAction(
        Object.assign(params, { limit }),
      );

      this.setState({
        tableItems: newData.items,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
    } catch (e) {
      this.setState({
        notFoundMessage: __('Pri načítaní dát sa vyskytla chyba'),
        loading: false,
      });
    }
  }

  handleSorter(s) {
    const { sorter } = this.state;
    let newSorter = sorter;

    if (sorter === s) {
      newSorter = `-${s}`;
    } else {
      newSorter = s;
    }

    this.setState({ sorter: newSorter }, () => this.fetchData());
  }

  onRowClicked(index) {
    const id = this.state.tableItems[index]._id;

    this.props.history.push(`/settings/users/${id}`);
  }

  createColumns(sorter) {
    const result = [
      {
        accessor: 'name',
        Header: () => (
          <IconTd
            onClick={() => this.handleSorter('name')}
            sorter={sorter === 'name' || sorter === '-name' ? sorter : null}
          >
            {__('Meno')}
          </IconTd>
        ),
        Cell: props => {
          return (
            <P>
              <NameWrapper>
                <UserImage
                  src={[
                    `${baseURL}/images/40x0/${props.original.image}`,
                    placeholder,
                  ]}
                />
                {props.value && `${props.value} ${props.original.surname}`}
              </NameWrapper>
            </P>
          );
        },
      },
      {
        accessor: 'position',
        Header: () => <IconTd>{__('Funkcia')}</IconTd>,
        Cell: props => {
          return <P>{props.value || '-'}</P>;
        },
      },
      {
        accessor: 'phone',
        Header: () => <IconTd>{__('Telefón')}</IconTd>,
        Cell: props => {
          return <P>{props.value || '-'}</P>;
        },
      },
      {
        accessor: 'email',
        Header: () => <IconTd>{__('Email')}</IconTd>,
        Cell: props => {
          return <P>{props.value || '-'}</P>;
        },
      },
      {
        accessor: 'b2b_role',
        Header: () => <IconTd>{__('Práva')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {props.value && b2bRoles.find(b => b.value === props.value)
                ? b2bRoles.find(b => b.value === props.value).label
                : '-'}
            </P>
          );
        },
      },
      {
        accessor: 'state',
        Header: () => <IconTd>{__('Stav')}</IconTd>,
        Cell: props => {
          return (
            <P>{props.value === 'active' ? __('Aktívny') : __('Neaktívny')}</P>
          );
        },
      },
    ];

    return result;
  }

  openMarketingMaterial(id) {
    this.props.history.push(`/marketing/materials/${id}`);
  }

  renderCustomHeaderContent() {
    return (
      <CheckAccess
        operation="postB2BUserAction"
        Component={
          <Button
            style={{ height: rem(15) }}
            icon="plus"
            extrasmall
            primary
            onClick={() => this.props.history.push(`/settings/users/new`)}
          >
            {__('Vytvoriť')}
          </Button>
        }
      />
    );
  }

  render() {
    return <React.Fragment>{super.render()}</React.Fragment>;
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Users);



// WEBPACK FOOTER //
// ./src/Containers/Settings/Users/List/index.jsx